import api from './api'
import type { User } from '@/types'

interface LoginPayload {
  email: string
  password: string
}

interface RegisterPayload {
  email: string
  password: string
  displayName: string
  invitationToken: string
  tenantId: string
}

export const authService = {
  async login(payload: LoginPayload) {
    const { data } = await api.post('/auth/login', payload)
    return data.data as { user: User; token: string }
  },

  async register(payload: RegisterPayload) {
    const { data } = await api.post(`/auth/register/${payload.tenantId}`, payload)
    return data.data as { user: User; token: string }
  },

  async registerWithInvite(token: string, password: string) {
    const { data } = await api.post('/auth/register-invite', { token, password })
    return data.data as { user: User; token: string }
  },

  async me() {
    const { data } = await api.get('/auth/me')
    return data.data as User
  },

  async forgotPassword(email: string) {
    const { data } = await api.post('/auth/forgot-password', { email })
    return data.data as { message: string }
  },

  async resetPassword(token: string, password: string) {
    const { data } = await api.post('/auth/reset-password', { token, password })
    return data.data as { message: string }
  },

  async refreshToken(token: string) {
    const { data } = await api.post('/auth/refresh', {}, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return data.data as { token: string }
  },

  async logout() {
    await api.post('/auth/logout')
  },
}
